import { useState } from "react";
import type { ProjectScript } from "../types";

export function useProjectScriptDeletion(options: {
  readonly editingScript: ProjectScript | null;
  readonly onDeleteScript: (id: string, expected: ProjectScript) => Promise<void> | void;
  readonly setDialogOpen: (open: boolean) => void;
  readonly setDeleteConfirmOpen: (open: boolean) => void;
  readonly setValidationError: (message: string) => void;
}) {
  const [deleting, setDeleting] = useState(false);
  const confirmDeleteScript = async () => {
    if (!options.editingScript || deleting) return;
    setDeleting(true);
    try {
      await options.onDeleteScript(options.editingScript.id, options.editingScript);
      options.setDialogOpen(false);
    } catch (error) {
      options.setValidationError(
        error instanceof Error ? error.message : "Could not remove action. Try again.",
      );
    } finally {
      options.setDeleteConfirmOpen(false);
      setDeleting(false);
    }
  };
  return { deleting, confirmDeleteScript };
}
